// extracted by mini-css-extract-plugin
module.exports = {"root":"c8DCE","bg":"_29Rf-"};